// Открытые редакторы кода по id листинга: чтобы переводить в них фокус из документа (Enter в названии,
// «```» в начале строки, вставка листинга).
import type { EditorView } from '@codemirror/view';

export const codeViews = new Map<string, EditorView>();

/** Фокус в редактор кода листинга id (после отрисовки node view). */
export function focusCode(id: string, where: 'start' | 'end' = 'start', tries = 20) {
  const v = codeViews.get(id);
  if (!v) { if (tries > 0) setTimeout(() => focusCode(id, where, tries - 1), 30); return; }
  v.focus();
  const pos = where === 'start' ? 0 : v.state.doc.length;
  v.dispatch({ selection: { anchor: pos }, scrollIntoView: true });
}
